<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('accounts')">Cuenta</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
     
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
     {{ /* Acordion */}}
    
     {{ /* Acordion */}}

    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import FileInput from '@/Shared/FileInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'




export default {
  metaInfo() {
    return {
      title: 'Account Plan',
    }
  },
  components: {
    FileInput,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,  
  },
  layout: Layout,
  props: {
    data: Array,
  },
  remember: 'form',
  data() {
    return {
      countris: this.countries,
      form: this.$inertia.form({
        _method: 'put',
       
      }),
    }
  },
  methods: {
   /*  update() {
      this.form.post(this.route('account.update', this.data.id), {
      })
    },
    destroy() {
      if (confirm('Está seguro de Eliminar esta Cuenta?')) {
        this.$inertia.delete(this.route('account.destroy', this.data.id))
      }
    },
    restore() {
      if (confirm('Está seguro de Restaurar esta Cuenta?')) {
        this.$inertia.put(this.route('account.restore', this.data.id))
      }
    },*/
  },
}
</script>